export default __webpack_public_path__ + "static/media/start-en.f7b1cb08.jpg";